/* NIBBLE & NABBLE 3.0 — Delivery Scheduler
 Native pickup date/time picker. Writes cart attributes via /cart/update.js.
   Gates checkout until a date + window are chosen. No dependencies. */
(function () {
  'use strict';

  var COPY = {
    locked: "Delivery locked in. We'll bring the goods to you!",
    pickFirst: "Pick your delivery date and window first.",
    saveError: "Couldn't save your delivery time. Try again?"
  };

  var state = { dateIso: null, dateLabel: null, windowLabel: null, note: '', cartCount: null, enabled: false, pausedMessage: '' };
  var instances = [];
  var saveTimer = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function label(d) {
    return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function lines(str) {
    return (str || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function parseTime(str) {
    str = (str || '').trim();
    var m = str.match(/^(\d{1,2})(?::(\d{2}))?\s*([ap]\.?m\.?)?$/i);
    if (!m) return null;
    var h = +m[1], min = m[2] ? +m[2] : 0;
    var ap = m[3] ? m[3].toLowerCase().charAt(0) : null;
    if (ap) { if (h === 12) h = (ap === 'a') ? 0 : 12; else if (ap === 'p') h += 12; }
    if (h > 23 || min > 59) return null;
    return h * 60 + min;
  }
  function fmt12(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }

  function scheduled() { return state.enabled && !!(state.dateIso && state.windowLabel); }
  function cartHasItems() {
    if (state.cartCount !== null) return state.cartCount > 0;
    var badge = document.querySelector('.nn-nav__cart-count');
    return !!(badge && parseInt(badge.textContent || '0', 10) > 0);
  }

  /* ---- persistence ---- */
  function saveAttributes() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Delivery Date': state.dateLabel || '',
        'Delivery Date ISO': state.dateIso || '',
        'Delivery Window': state.windowLabel || '',
        'Delivery Note': state.note || ''
      }})
    }).then(function (r) { if (!r.ok) throw new Error('save failed'); return r.json(); });
  }
  function persist() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      saveAttributes()
        .then(function () { instances.forEach(function (i) { i.renderStatus(false); }); })
        .catch(function () { instances.forEach(function (i) { i.renderStatus(true); }); });
    }, 250);
  }

  /* ---- checkout gating ---- */
  function checkoutLinks() {
    return document.querySelectorAll('a[href$="/checkout"], a[href="/checkout"], form[action$="/checkout"] [type="submit"]');
  }
  function applyGate() {
    var block = state.enabled && cartHasItems() && !scheduled();
    checkoutLinks().forEach(function (el) {
      el.classList.toggle('nn-checkout--gated', block);
      if (block) { el.setAttribute('aria-disabled', 'true'); }
      else { el.removeAttribute('aria-disabled'); }
    });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[href$="/checkout"], a[href="/checkout"]');
    if (!el) return;
    if (state.enabled && cartHasItems() && !scheduled()) {
      e.preventDefault();
      instances.forEach(function (inst) {
        if (inst.offsetParent !== null) {
          inst.showHint(null);
          var sel = inst.querySelector('[data-delivery-date]');
          if (sel) sel.focus();
        }
      });
    }
  }, true);

  /* ---- component ---- */
  var proto = Object.create(HTMLElement.prototype);

  proto.connectedCallback = function () {
    if (this.dataset.init === '1') return;
    this.dataset.init = '1';
    instances.push(this);
    var cfgEl = this.querySelector('[data-delivery-config]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { this.cfg = null; }
    if (!this.cfg) return;
    state.enabled = this.cfg.enabled === true;
    state.pausedMessage = this.cfg.pausedMessage || '';
    this.cfg.blackouts = this.cfg.blackoutsRaw || [];
    var sv = this.cfg.saved || {};
    if (state.dateIso === null && sv.dateIso) {
      state.dateIso = sv.dateIso;
      state.windowLabel = sv.window || null;
      state.note = sv.note || '';
    }
    this.buildDates();
    this.bind();
    this.render();
    applyGate();
  };

  proto.availableDates = function () {
    var out = [], cfg = this.cfg;
    var windowsByDay = cfg.windowsByDay || {};
    if (!cfg.openDays || !cfg.openDays.length) return out;
    var now = new Date();
    var earliest = new Date(now.getTime() + (cfg.leadHours || 0) * 3600000);
    for (var i = 0; i < (cfg.daysAhead || 14); i++) {
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      if (cfg.openDays.indexOf(d.getDay()) === -1) continue;
      var dayIso = iso(d);
      if ((cfg.blackouts || []).indexOf(dayIso) !== -1) continue;
      var dayWindows = windowsByDay[String(d.getDay())] || windowsByDay[d.getDay()] || [];
      var ok = dayWindows.some(function (w) {
        var startMin = parseTime(w.start);
        if (startMin === null) return false;
        var startAt = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(startMin / 60), startMin % 60);
        return startAt >= earliest;
      });
      if (ok) out.push(d);
    }
    return out;
  };

  proto.buildDates = function () {
    if (!state.enabled) return;
    var sel = this.querySelector('[data-delivery-date]');
    if (!sel) return;
    var dates = this.availableDates();
    var opts = ['<option value="">Choose a date</option>'];
    dates.forEach(function (d) {
      var v = iso(d), txt = label(d);
      opts.push('<option value="' + v + '" data-label="' + label(d) + '">' + txt + '</option>');
    });
    sel.innerHTML = opts.join('');
    if (state.dateIso) sel.value = state.dateIso;
  };

  proto.buildWindows = function () {
    var wrap = this.querySelector('[data-delivery-windows]');
    if (!wrap) return;
    var cfg = this.cfg;
    if (!state.dateIso) { wrap.innerHTML = ''; return; }
    var parts = state.dateIso.split('-');
    var d = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var dayWindows = (cfg.windowsByDay || {})[String(d.getDay())] || (cfg.windowsByDay || {})[d.getDay()] || [];
    var earliest = new Date(Date.now() + (cfg.leadHours || 0) * 3600000);
    wrap.innerHTML = dayWindows.map(function (w) {
      var startMin = parseTime(w.start);
      var endMin = parseTime(w.end);
      if (startMin === null || endMin === null) return '';
      var startAt = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(startMin / 60), startMin % 60);
      if (startAt < earliest) return '';
      var startFmt = fmt12(startMin), endFmt = fmt12(endMin);
      var full = w.label + ' (' + startFmt + ' to ' + endFmt + ')';
      var on = state.windowLabel === full;
      return '<button type="button" class="nn-pickup__window' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-window="' + full.replace(/"/g, '&quot;') + '">' + w.label + '<span class="nn-pickup__window-time">' + startFmt + ' to ' + endFmt + '</span></button>';
    }).join('');
  };

  proto.render = function () {
    this.buildWindows();
    var note = this.querySelector('[data-delivery-note]');
    if (note && note.value !== state.note) note.value = state.note;
    var sel = this.querySelector('[data-delivery-date]');
    if (sel && sel.value !== (state.dateIso || '')) sel.value = state.dateIso || '';
    this.renderStatus(false);
  };

  proto.renderStatus = function (isError) {
    var st = this.querySelector('[data-delivery-status]');
    if (!st) return;
    st.classList.toggle('is-error', !!isError);
    st.textContent = isError ? COPY.saveError : (scheduled() ? COPY.locked : '');
  };

  proto.showHint = function (msg) {
    var st = this.querySelector('[data-delivery-status]');
    if (!st) { if (msg) alert(msg); return; }
    st.classList.add('is-error');
    st.textContent = msg || COPY.pickFirst;
  };

  proto.bind = function () {
    var sel = this.querySelector('[data-delivery-date]');
    if (sel) {
      sel.addEventListener('change', function () {
        state.dateIso = sel.value || null;
        var opt = sel.options[sel.selectedIndex];
        state.dateLabel = (opt && opt.getAttribute('data-label')) || null;
        state.windowLabel = null;
        broadcast(); persist();
      });
    }
    this.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-window]');
      if (!btn) return;
      state.windowLabel = btn.getAttribute('data-window');
      broadcast(); persist();
    });
    var note = this.querySelector('[data-delivery-note]');
    if (note) {
      note.addEventListener('input', function () {
        state.note = note.value.slice(0, 200);
        persist();
      });
    }
  };

  function broadcast() {
    instances.forEach(function (inst) { inst.render(); });
    applyGate();
  }

  document.addEventListener('nn:cart:updated', function (e) {
    state.cartCount = e.detail && typeof e.detail.count === 'number' ? e.detail.count : state.cartCount;
    applyGate();
  });

  function NNDeliveryScheduler() { return Reflect.construct(HTMLElement, [], NNDeliveryScheduler); }
  NNDeliveryScheduler.prototype = proto;
  Object.setPrototypeOf(NNDeliveryScheduler, HTMLElement);
  if (window.customElements && !customElements.get('nn-delivery-scheduler')) {
    customElements.define('nn-delivery-scheduler', NNDeliveryScheduler);
  }
})();